





















































































import { Component, Mixins, Prop, Vue, Ref } from 'vue-property-decorator'
import Project from '@/projects/entities/project'
import projectsService from '@/projects/services/projects-service'

@Component
export default class PartlistUploadDialog extends Vue {
  @Ref()
  private validator!: ValidationObserver

  private dialog = false
  private loading = false

  private project: Project | null = null

  private imosFile = new File([''], '')
  private imosWarnings: string = ''

  private notheggerFile = new File([''], '')
  private notheggerWarnings: string = ''

  public open(project: Project) {
    this.project = project
    this.dialog = true
  }

  private async confirm() {
    if (await this.validator.validate()) {
      this.loading = true
      if (this.imosFile) {
        await this.uploadImosFile(this.imosFile)
      }
      if (this.notheggerFile) {
        await this.uploadNotheggerFile(this.notheggerFile)
      }
      this.$emit('imported')
      this.loading = false
      if (this.imosWarnings.length === 0 && this.notheggerWarnings.length === 0) {
        this.reset()
        this.cancel()
      }
    }
  }

  public async uploadImosFile(file: File) {
    if (file.size > 0 && this.project) {
      const result = await projectsService.importImosAsync(
        this.project.id,
        file
      )
      this.imosWarnings = result
    }
  }

  public async uploadNotheggerFile(file: File) {
    if (file.size > 0 && this.project) {
      const result = await projectsService.importNotheggerAsync(
        this.project.id,
        file
      )
      this.notheggerWarnings = result
    }
  }

  private reset() {
    if (this.validator) {
      this.validator.reset()
    }
  }

  private cancel() {
    this.dialog = false
  }
}
